import commonEn from "./locales/en/common";
import legalEn from "./locales/en/legal";
import commonFr from "./locales/fr/common";
import legalFr from "./locales/fr/legal";
import commonEs from "./locales/es/common";
import legalEs from "./locales/es/legal";
import commonDe from "./locales/de/common";
import legalDe from "./locales/de/legal";
import commonPt from "./locales/pt/common";
import legalPt from "./locales/pt/legal";
import commonIt from "./locales/it/common";
import legalIt from "./locales/it/legal";
import mobileResources from "./mobileResources";

const resources = {
  en: {
    common: commonEn,
    legal: legalEn,
    mobile: mobileResources.en.mobile,
  },
  fr: {
    common: commonFr,
    legal: legalFr,
    mobile: mobileResources.fr.mobile,
  },
  es: {
    common: commonEs,
    legal: legalEs,
    mobile: mobileResources.es.mobile,
  },
  de: {
    common: commonDe,
    legal: legalDe,
    mobile: mobileResources.de.mobile,
  },
  pt: {
    common: commonPt,
    legal: legalPt,
    mobile: mobileResources.pt.mobile,
  },
  it: {
    common: commonIt,
    legal: legalIt,
    mobile: mobileResources.it.mobile,
  },
};

export default resources;
